import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a tall pantry unit, 0.6 x 0.6 x 2.2 m, back flush at
// z = -0.3 (stands against a wall on the -Z side), two door fronts.
const CARCASS = "#e8e4dc";
const FRONT = "#efece6";
const MATTE_BLACK = "#2e2e30";

export const kitchenCabinetTall = defineModel({
  id: "kitchen-cabinet-tall",
  batchId: "modern",
  name: "Kitchen cabinet (tall)",
  tags: ["modern", "interior", "furniture", "kitchen", "storage", "pantry"],
  summary: "A tall kitchen pantry unit with upper and lower door fronts.",
  tiles: { w: 1, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.54, 0.1, 0.5), color: MATTE_BLACK, position: [0, 0.05, -0.04] },
      // cabinet body (back flush at z = -0.3, top at 2.2)
      { geometry: new THREE.BoxGeometry(0.6, 2.1, 0.56), color: CARCASS, position: [0, 1.15, -0.02] },
      // lower door front
      { geometry: new THREE.BoxGeometry(0.56, 0.86, 0.02), color: FRONT, position: [0, 0.54, 0.27] },
      // upper door front
      { geometry: new THREE.BoxGeometry(0.56, 1.16, 0.02), color: FRONT, position: [0, 1.6, 0.27] },
      // vertical bar handles at the split
      { geometry: new THREE.BoxGeometry(0.02, 0.16, 0.02), color: MATTE_BLACK, position: [0.22, 0.88, 0.29] },
      { geometry: new THREE.BoxGeometry(0.02, 0.16, 0.02), color: MATTE_BLACK, position: [0.22, 1.12, 0.29] },
    ];
  },
  animations: [],
});
